import { Box } from "@mui/system";
import _ from "lodash";
import FacebookMediaCardEmptyState from "./FacebookMediaCardEmptyState";
import useFacebookMedia from "../../../../hooks/Message/Conversation/useFacebookMedia";
import { metaMediaType } from "../../../../utilities/MetaUtils";

export default function FacebookVideoCard({ videoId }) {
    const { loading, media, error } = useFacebookMedia(videoId, metaMediaType.VIDEO);

    if (loading || _.isEmpty(media)) {
        return <FacebookMediaCardEmptyState />;
    }

    return (
        <Box>
            <video
                src={media?.url}
                controls
                style={{ ...styles.video, ...{ width: `${media?.width || 300}px`, maxWidth: '100%' } }}
            />
        </Box>
    );
}

const styles = {
    video: {
        borderRadius: '5px',
        border: '1px solid #C1C1C1'
    }
};
